import {useCallback} from 'react'

import {Notification, useNotificationsContext} from './NotificationsContext'

export const useNotifications = (): Notification[] => {
  return useNotificationsContext()[0]
}

export const useNotificationCallback = () => {
  const [, dispatch] = useNotificationsContext()

  return useCallback(
    (notification: Notification) => {
      dispatch({type: 'add', payload: notification})

      return () => {
        dispatch({type: 'remove', payload: notification})
      }
    },
    [dispatch],
  )
}
